export default "__VITE_ASSET__rZln8LMF__"